import { Component, EventEmitter, Output, Input } from '@angular/core';
import { ConfirmOutput } from '@app/cp/shared/models/ConfirmOutput';
import { CPDialogResult } from '@app/cp/shared/enums/CPDialogResult';
import { CRUDActions } from '@app/cp/shared/enums/CRUDActions';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

@Component({
    selector: 'inventory-location-dialog',
    templateUrl: './inventory-location-dialog.component.html',
    styleUrls: ['./inventory-location-dialog.component.scss'],
    standalone: false
})
export class InventoryLocationDialogComponent   {
    inventoryLocationId: any;

    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };
    _active: boolean = false;
    @Input() set active(value: boolean) {
        this.inventoryLocationId = null;

        this._active = value;
    }
    @Input() code: string = "LocationForQuantity";

    @Input() message: string = "Select Location to Transfer the Excess Inventory To";
    @Output() closed: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    cboChanged(e: any) { }
    ok() {
        let result: ConfirmOutput = { action: CRUDActions.None, dialogResult: CPDialogResult.ok, data: this.inventoryLocationId, code: this.code }
        this.closed.emit(result);
        this.hide();
    }
    cancel() {
        let result: ConfirmOutput = { action: CRUDActions.None, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.closed.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: CRUDActions.None, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.closed.emit(result);
        this.hide();
    }
    hide() {
        this.active = false;
        this.message = null;
    }

}

